import { render, staticRenderFns } from "./dictionary-export.vue?vue&type=template&id=532702c1"
import script from "./dictionary-export.vue?vue&type=script&lang=js"
export * from "./dictionary-export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports